/**
 * 业务线枚举
 */
export var BizLine;
(function (BizLine) {
    BizLine[BizLine["Hotel"] = 1] = "Hotel";
    // 境内住宿
    BizLine[BizLine["Air"] = 2] = "Air";
    // 机票
    BizLine[BizLine["Train"] = 3] = "Train";
    // 火车票
    BizLine[BizLine["HomeStay"] = 4] = "HomeStay";
    // 民宿
    BizLine[BizLine["Ticket"] = 5] = "Ticket";
    // 门票
    BizLine[BizLine["Vacation"] = 6] = "Vacation";
    // 度假
    BizLine[BizLine["OverseaHotel"] = 7] = "OverseaHotel";
    // 境外住宿
    BizLine[BizLine["Car"] = 8] = "Car";
    // 打车
    BizLine[BizLine["OverseaTicket"] = 9] = "OverseaTicket"; // 境外门票
})(BizLine || (BizLine = {}));
export const BizLineDesc = {
    [BizLine.Hotel]: '酒店',
    [BizLine.Air]: '机票',
    [BizLine.Train]: '火车票',
    [BizLine.HomeStay]: '民宿',
    [BizLine.Ticket]: '门票',
    [BizLine.Vacation]: '度假',
    [BizLine.OverseaHotel]: '境外住宿',
    [BizLine.Car]: '打车',
    [BizLine.OverseaTicket]: '境外门票'
};
/** 奖励类型枚举 rewardType：next券1 god券2 积分3 实物4，11 免单卡 */
export var RewardType;
(function (RewardType) {
    RewardType[RewardType["NEXT_COUPON"] = 1] = "NEXT_COUPON";
    RewardType[RewardType["GOD_COUPON"] = 2] = "GOD_COUPON";
    RewardType[RewardType["POINTS"] = 3] = "POINTS";
    RewardType[RewardType["PHYSICAL"] = 4] = "PHYSICAL";
    RewardType[RewardType["FREE_CARD"] = 11] = "FREE_CARD";
})(RewardType || (RewardType = {}));
/** prizeStatus 奖励展示状态 */
export var PrizeStatus;
(function (PrizeStatus) {
    /** 可领取 */
    PrizeStatus[PrizeStatus["CLAIMABLE"] = 1] = "CLAIMABLE";
    /** 不可领取 */
    PrizeStatus[PrizeStatus["NOT_CLAIMABLE"] = 2] = "NOT_CLAIMABLE";
    /** 未使用 */
    PrizeStatus[PrizeStatus["NOT_USED"] = 3] = "NOT_USED";
    /** 已使用 */
    PrizeStatus[PrizeStatus["USED"] = 4] = "USED";
    /** 已过期 */
    PrizeStatus[PrizeStatus["EXPIRED"] = 5] = "EXPIRED";
    /** 预先领取 */
    PrizeStatus[PrizeStatus["PRE_CLAIMED"] = 6] = "PRE_CLAIMED";
    /** 已领取 */
    PrizeStatus[PrizeStatus["CLAIMED"] = 7] = "CLAIMED";
})(PrizeStatus || (PrizeStatus = {}));
export var AmountType;
(function (AmountType) {
    AmountType[AmountType["THRESHOLD"] = 1] = "THRESHOLD";
    AmountType[AmountType["DISCOUNT"] = 2] = "DISCOUNT";
})(AmountType || (AmountType = {}));
export var FreeOrderCardStatus;
(function (FreeOrderCardStatus) {
    /** 待使用 */
    FreeOrderCardStatus[FreeOrderCardStatus["TO_BE_USED"] = 1] = "TO_BE_USED";
    /** 已使用 */
    FreeOrderCardStatus[FreeOrderCardStatus["USED"] = 2] = "USED";
    /** 已过期 */
    FreeOrderCardStatus[FreeOrderCardStatus["EXPIRED"] = 3] = "EXPIRED";
})(FreeOrderCardStatus || (FreeOrderCardStatus = {}));
